<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.add_mixer' | translate }}
    v-card-content
      v-input.mb-3(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        @input="clearError('name')"
        v-model="payload.name")
      .cols-x
        .cols-x__2
          v-input.mb-3(
            :label="$t('base.capacity_from')"
            :hint="errorMessage('min_weight')"
            :invalid="!!errorMessage('min_weight')"
            @input="clearError('min_weight')"
            v-model="payload.min_weight")
        .cols-x__2
          v-input.mb-3(
            :label="$t('base.capacity_to')"
            :hint="errorMessage('max_weight')"
            :invalid="!!errorMessage('max_weight')"
            @input="clearError('max_weight')"
            v-model="payload.max_weight")
      v-switch.mb-3(
        :label="$t('base.weight_up')"
        v-model="payload.up_down")
      //- v-switch.mb-3(
      //-   :label="$t('base.rounding')"
      //-   v-model="payload.rounding")
      //- v-range(
      //-   :max="100"
      //-   :label="$t('reports.auger_rotations')"
      //-   v-model="payload.auger_rotations")
      //- v-range(
      //-   :max="100"
      //-   :label="$t('reports.auger_rotations_coefficient')"
      //-   v-model="payload.auger_rotations_coefficient")
      //- v-range(
      //-   :min="90"
      //-   :label="$t('base.download_admittance')"
      //-   v-model="payload.loading.admittance")
      //- v-range(
      //-   :label="$t('base.download_sensitivity')"
      //-   v-model="payload.loading.sensitivity")
      //- v-range(
      //-   :min="90"
      //-   :label="$t('base.unloading_admittance')"
      //-   v-model="payload.unloading.admittance")
      //- v-range(
      //-   :label="$t('base.unloading_sensitivity')"
      //-   v-model="payload.unloading.sensitivity")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onCreate")
        | {{ 'base.add' | translate }}
      v-btn(
        text
        @click="onClose")
        | {{ 'base.close' | translate }}
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'CreateModal',
  mixins: [formErrorsMixin],
  data: () => ({
    payload: {
      name: null,
      min_weight: 1,
      max_weight: 10,
      up_down: false,
      // rounding: false,
      auger_rotations: 100,
      auger_rotations_coefficient: 100,
      // loading: {
      //   admittance: 100,
      //   sensitivity: 100,
      //   ladle: 0
      // },
      // unloading: {
      //   admittance: 100,
      //   sensitivity: 100
      // }
    },
    errors: {
      name: null,
      min_weight: null,
      max_weight: null,
    },
    loading: false
  }),

  methods: {
    ...mapActions('mixers', [
      'createMixer'
    ]),

    async onCreate () {
      const payload = {
        farm: this.$route.params.farm_id,
        ...this.payload
      }
      if (!this.checkValidData()) return
      this.loading = true

      const { errors } = await api.mixers.create(payload)
      this.errors = errors
      if (!errors) {
        await this.createMixer(payload)
        this.$emit('close')
      }

      this.loading = false
    },
    checkValidData () {
      let valid = true
      this.errors.name = null
      this.errors.min_weight = null
      this.errors.max_weight = null

      const minWeight = Number(this.payload.min_weight)
      const maxWeight = Number(this.payload.max_weight)

      if (!this.payload.name) {
        this.errors.name = this.errors.name = ['3']
        valid = false
      } else if (this.payload.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
        valid = false
      }

      if (this.payload.min_weight === null || isNaN(minWeight) || minWeight < 0) {
        this.errors.min_weight = ['9']
        valid = false
      }
      if (minWeight < 1) {
        this.errors.min_weight = ['min_val', 1]
        valid = false
      }

      if (this.payload.max_weight === null || isNaN(maxWeight) || maxWeight < 0) {
        this.errors.max_weight = ['9']
        valid = false
      }

      if (minWeight > maxWeight) {
        this.errors.min_weight = ['8']
        valid = false
      }

      return valid
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>
